import { useRef, useState } from "react";
import { motion } from "framer-motion";

const BEFORE = "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/fc999244ad71fee642696dd41358fa303ac43bd3fee06635e6f01388071dd996.png";
const AFTER = "https://static.prod-images.emergentagent.com/jobs/389db444-e3c2-4bcc-82f1-4e5bf1ac1d53/images/bef13f1daac35a77b0153bac43c927e36792ce732857819bd0c65d07f4fbcaf3.png";

export default function BeforeAfter() {
  const [pos, setPos] = useState(50);
  const ref = useRef(null);

  const move = (clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    const x = Math.max(0, Math.min(rect.width, clientX - rect.left));
    setPos((x / rect.width) * 100);
  };

  return (
    <section data-testid="before-after-section" className="section bg-bone">
      <div className="container-max">
        <div className="grid grid-cols-12 gap-8 items-end mb-12">
          <div className="col-span-12 md:col-span-6">
            <p className="overline">— Avant / Après</p>
            <h2 className="font-display font-light text-5xl md:text-7xl leading-[0.95] tracking-tighter mt-6">
              Le même volume,<br />
              <em className="italic text-terracotta">métamorphosé</em>.
            </h2>
          </div>
          <div className="col-span-12 md:col-span-5 md:col-start-8">
            <p className="text-ink/70 text-lg leading-relaxed">
              Glissez le curseur pour révéler la transformation : appartement parc Monceau, 142 m², seize semaines de chantier.
            </p>
          </div>
        </div>

        <motion.div
          ref={ref}
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1 }}
          data-testid="before-after-slider"
          className="relative w-full aspect-[16/10] overflow-hidden select-none cursor-ew-resize"
          onMouseMove={(e) => e.buttons === 1 && move(e.clientX)}
          onMouseDown={(e) => move(e.clientX)}
          onTouchMove={(e) => move(e.touches[0].clientX)}
        >
          <img src={AFTER} alt="Appartement haussmannien après rénovation" className="absolute inset-0 w-full h-full object-cover" />
          <div className="absolute inset-0 overflow-hidden" style={{ width: `${pos}%` }}>
            <img src={BEFORE} alt="Appartement haussmannien avant rénovation" className="absolute inset-0 w-full h-full object-cover" style={{ width: `${10000 / pos}%`, maxWidth: "none" }} />
          </div>

          <div className="absolute top-0 bottom-0" style={{ left: `${pos}%`, transform: "translateX(-50%)" }}>
            <div className="w-px h-full bg-bone shadow-[0_0_30px_rgba(0,0,0,0.4)]" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-14 h-14 bg-bone border border-ink flex items-center justify-center">
              <span className="font-mono text-xs tracking-widest">‹ ›</span>
            </div>
          </div>

          <span className="absolute top-6 left-6 overline bg-bone/80 backdrop-blur px-3 py-1">Avant</span>
          <span className="absolute top-6 right-6 overline bg-ink text-bone px-3 py-1">Après</span>
        </motion.div>

        <input
          data-testid="before-after-input"
          type="range"
          min="0"
          max="100"
          value={pos}
          onChange={(e) => setPos(Number(e.target.value))}
          className="w-full mt-8 accent-terracotta"
          aria-label="Curseur avant/après"
        />
      </div>
    </section>
  );
}
